export default __webpack_public_path__ + "static/media/duration.8fcc6e81.svg";